import dayjs from 'dayjs';

/**
 * Calculates the number of months between two dates (inclusive).
 * @param startDate - The start date
 * @param endDate - The end date
 * @returns The number of months between the dates (minimum 1)
 */
export function calculateMonthsBetween(startDate: string | Date, endDate: string | Date): number {
  if (!startDate || !endDate) {
    return 12; // Default to 12 months if dates are not provided
  }

  const start = dayjs(startDate);
  const end = dayjs(endDate);

  if (!start.isValid() || !end.isValid()) {
    return 12; // Default to 12 months if dates are invalid
  }

  // Calculate the difference in months
  const months = end.diff(start, 'month') + 1; // +1 to make it inclusive

  // Ensure at least 1 month
  return Math.max(1, months);
}

